import { useTranslation } from 'react-i18next'

import { Text } from '@/components/ui/Text'

export function TwinChatUnavailable() {
  const { t } = useTranslation('app')
  return (
    <div className="flex min-h-[40vh] items-center justify-center p-8">
      <Text color="muted" className="max-w-md text-center">
        {t('blockedFeature.twinChat')}
      </Text>
    </div>
  )
}
